<template>
    <el-dialog
        class="sn-system-module-dialog"
        :width="dialogWidth"
        :title="$translate('lang.E3202110110011', { defaultText: '新增/修改' }) "
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        :close-on-click-modal="false">
        <el-form ref="ruleForm" class="row-box" :model="ruleForm" :rules="verification" :label-position="labelPosition">
            <el-row>
                <el-col class="select-box1"  v-for="(item, index) in selectColumns" :key="index" :span="item.span?item.span:8">
                    <el-form-item  :label="item.label+'：'" :label-width="item.labelWidth||deafultLabelWidth" :prop="item.prop">
                        <div v-if="item.amendState && amendState">
                            <el-select v-model="ruleForm[item.prop]" v-if="item.type === 'select'" disabled>
                                <el-option v-for="(val, index) in item.options" :key='index' :label="val.label" :value="val.value"></el-option>
                            </el-select>
                            <el-checkbox v-else-if="item.type === 'checkbox'" v-model="ruleForm[item.prop]"></el-checkbox>
                            <el-input v-else v-model.number="ruleForm[item.prop]" disabled></el-input>
                        </div>
                        <div v-else>
                                    <el-select
                                        class="sn-system-module-dialog-select"
                                        v-model="ruleForm[item.prop]"
                                        v-if="item.type === 'select'"
                                        :clearable="clearable"
                                        collapse-tags
                                        :placeholder="item.placeholder"
                                        :multiple="item.multiple ? item.multiple : false">
                                        <el-option
                                            v-for="(val, index) in item.options"
                                            :key='index'
                                            :label="val.label"
                                            :value="item.ganged ? (val.value+','+val.label) : val.value">
                                        </el-option>
                                    </el-select>
                                    <el-select
                                        v-else-if="item.type === 'autocomplete'"
                                        v-model="ruleForm[item.prop]"
                                        filterable
                                        remote
                                        reserve-keyword
                                        clearable
                                        :multiple="item.multiple?item.multiple:false"
                                        :remote-method="remoteMethod"
                                        :loading="searchLoading"
                                        @change="autocompleteSure"
                                        @focus="searchDateChange(item)">
                                        <el-option
                                            v-for="(item, optIndex) in options"
                                            :key="optIndex"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <el-switch
                                        v-else-if="item.type === 'switch'"
                                        v-model="ruleForm[item.prop]"
                                        class="demo"
                                        :active-value="item.activeValue || 'Y'"
                                        :inactive-value="item.inactiveValue || 'N'"
                                        :active-text="$translate('lang.E3202102260004', { defaultText: '启用' })"
                                        :inactive-text="$translate('lang.E3202102260003', { defaultText: '停用' })">
                                    </el-switch>
                                    <el-input
                                        v-else-if="item.type === 'advance'"
                                        v-model="ruleForm[item.prop]" clearable
                                        @keyup.113.native="detaliSearch(item.prop, item, 2, ruleForm)"
                                        @keyup.enter.native="detaliSearch(item.prop, item, 2, ruleForm)"
                                        @input="advanceCodeChange(item)"
                                        @clear="advanceCodeChange(item)">
                                        <el-button slot="append" @click="detaliSearch(item.prop, item, 2, ruleForm)" icon="el-icon-search"></el-button>
                                    </el-input>
                                    <el-checkbox v-else-if="item.type === 'checkbox'" v-model="ruleForm[item.prop]" disabled></el-checkbox>
                                    <el-input v-else-if="item.type === 'number'" v-model.number="ruleForm[item.prop]" clearable></el-input>
                                    <el-date-picker
                                        class='text-box'
                                        v-else-if="item.type === 'time'"
                                        v-model="ruleForm[item.prop]"
                                        size='mini'
                                        :type='item.timeType||"datetimerange"'
                                        :clearable="timeClearable"
                                        :format="item.format||'yyyy-MM-dd HH:mm:ss'"
                                        :value-format="item.format||'yyyy-MM-dd HH:mm:ss'"
                                        :start-placeholder="item.startPlaceholder ||$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                                        :end-placeholder="item.endPlaceholder || $translate('lang.E3202101270024', { defaultText: '结束日期' }) ">
                                    </el-date-picker>
                                    <el-input v-else v-model="ruleForm[item.prop]" :placeholder="item.placeholder" clearable></el-input>
                                </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeEdit" size="mini">{{$translate('lang.E3202101270002', { defaultText: '取消' })}}</el-button>
            <el-button type="primary" :loading="saveLoading" @click="confirm" size="mini">{{$translate('lang.E3202101270001', { defaultText: '确定' })}}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import _ from '@/components/lots/utils';
import { dictWithUrl } from '../api';
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        ruleForm: {
            type: Object,
            default() {
                return {};
            }
        },
        amendState: {
            type: Boolean,
            default() {
                return false;
            }
        },
        initTableColumns: {
            type: Array,
            default() {
                return [];
            }
        },
        saveLoading: {
            type: Boolean,
            default() {
                return false;
            }
        },
        dialogWidth: {
            type: String,
            default() {
                return '520px';
            }
        }
    },
    data() {
        return {
            clearable: true,
            selectColumns: [],
            deafultLabelWidth: '100px',
            labelPosition: 'right',
            cascaderConfig: {
                checkStrictly: true
            },
            dictuRL: '/api-sn/config/tenantSourcesysTable/getDictList'
        };
    },
    methods: {
        confirm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    const data = JSON.parse(JSON.stringify(this.ruleForm));
                    for (var a in data) {
                        if (data.hasOwnProperty(a) && typeof data[a] === 'string') {
                            data[a] = data[a].replace(/(^\s*)|(\s*$)/g, '');
                        }
                    }
                    this.$emit('saveData', data);
                }
            });
        },
        handleClose() {
            this.$emit('closeEdit', false);
        },
        closeEdit() {
            this.$emit('closeEdit', false);
        },
        // 初始化数字字典值
        getOptionList() {
            const optionList = [];
            const numList = [];
            this.initTableColumns.forEach((columns, index) => {
                if (columns.optionNum) {
                    optionList.push(columns.optionNum);
                    numList.push(index);
                }
            });
            if (optionList.length !== 0) {
                const params = {
                    dictCodes: optionList.join(',')
                };
                dictWithUrl(params, this.dictuRL).then(list => {
                    const optiondata = optionList.map(num => {
                        const option = [];
                        for (const key in list.data[num]) {
                            if (list.data[num].hasOwnProperty(key)) {
                                option.push({ 'value': _.get(list, `data.${num}.${key}.code`, ''), 'label': _.get(list, `data.${num}.${key}.name`, '') });
                            }
                        }
                        return option;
                    });
                    numList.forEach((data, index) => {
                        this.initTableColumns[data].options = optiondata[index];
                    });
                }).then(() => {
                    this.initColumns();
                });
            } else {
                this.initColumns();
            }
        },
        initColumns() {
            this.selectColumns = [];
            this.initTableColumns.forEach(item => {
                // 若 require 且 类型不为 isconceal
                if (item.require) {
                    this.selectColumns.push(item);
                    if (item.options) {
                        // 赋值
                        item.options.forEach(data => {
                            if (data.label === this.ruleForm[item.prop]) {
                                this.ruleForm[item.prop] = data.value;
                            }
                        });
                    }
                }
            });
        }
    },
    watch: {
        dialogVisible(newv, oldv) {
            if (newv) {
                this.getOptionList();
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            }
        }
    }
};
</script>
<style lang="less">
    .sn-system-module-dialog{
        .el-form-item{
            margin-bottom: 14px;
        }
        .sn-system-module-dialog-select{
            width: 100%;
        }
        .demo{
            .el-switch__label {
                position: absolute;
                display: none;
                color: #fff;
            }
            /*打开时文字位置设置*/
            .el-switch__label--right {
                z-index: 1;
                right: -10px;
            }
            /*关闭时文字位置设置*/
            .el-switch__label--left {
                z-index: 1;
                left: 26px;
            }
            /*显示文字*/
            .el-switch__label.is-active {
                display: block;
            }
            .el-switch__core,.el-switch__label{
                width: 60px !important;
            }
        }
        .cascader-box{
            .el-cascader{
                width: 100%;
            }
        }
    }
</style>